import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ThemeProvider as MuiThemeProvider, Theme, StyledEngineProvider } from '@mui/material/styles';

import { store, persistor } from 'application/redux/store';
import theme from 'ui/theme';

import 'ag-grid-community/styles/ag-grid.css'; // Core CSS
import 'ag-grid-community/styles/ag-theme-quartz.css'; // Theme
import 'ag-grid-community/styles/ag-theme-balham.css'; // Theme
import 'ag-grid-community/styles/ag-theme-material.css'; // Theme

import './index.css';
import { PersistGate } from 'redux-persist/integration/react';

import { AllEnterpriseModule, LicenseManager, ModuleRegistry } from 'ag-grid-enterprise';
import KurrentApp from 'KurrentApp';
import LrAuthentication from 'application/Providers/Authentication/index';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import Installation from './application/Providers/Installation';

declare module '@mui/styles/defaultTheme' {
    // tslint:disable-next-line:no-empty-interface
    interface DefaultTheme extends Theme {}
}

ModuleRegistry.registerModules([AllEnterpriseModule]);

LicenseManager.setLicenseKey(
    'Using_this_{AG_Grid}_Enterprise_key_{AG-092343}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Lumen_Risk_Services,_LLC}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Kurrent}_only_for_{2}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{Kurrent}_need_to_be_licensed___{Kurrent}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{27_October_2026}____[v3]_[01]_MTc5MzA1OTIwMDAwMA==e846f331d04cfd5f9c4ddeab5a73ec0e'
);

ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <BrowserRouter>
                <LrAuthentication>
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                        <StyledEngineProvider injectFirst>
                            <MuiThemeProvider theme={theme}>
                                <Installation productType={process.env.REACT_APP_PRODUCT}>
                                        <div>
                                            <KurrentApp />
                                        </div>
                                </Installation>
                            </MuiThemeProvider>
                        </StyledEngineProvider>
                    </LocalizationProvider>
                </LrAuthentication>
            </BrowserRouter>
        </PersistGate>
    </Provider>,
    document.getElementById('root') as HTMLElement
);
